import { AppTheme } from "@hex/common";

import { Theme } from "../theme/common/theme";
import { useDarkTheme } from "../theme/themes/darkTheme";
import { useLightTheme } from "../theme/themes/lightTheme";

import { usePrefersColorScheme } from "./usePrefersColorScheme";

export function useGetThemeTypeWithPreference(
  themeName: AppTheme,
): Exclude<AppTheme, "SYS_PREF"> {
  const preferredColorScheme = usePrefersColorScheme();
  if (themeName === AppTheme.SYS_PREF) {
    return preferredColorScheme;
  }
  return themeName;
}

export function useGetThemeFromName(themeName: AppTheme): Theme {
  const lightTheme = useLightTheme();
  const darkTheme = useDarkTheme();

  return useGetThemeTypeWithPreference(themeName) === AppTheme.DARK
    ? darkTheme
    : lightTheme;
}
